import React, { useState, useRef, useEffect } from "react";
import {
    UserOutlined,
    PhoneOutlined,
    MailOutlined,
    IdcardOutlined,
    CalendarOutlined,
    TeamOutlined,
    FileTextOutlined,
    ArrowLeftOutlined,
    CheckCircleOutlined,
    HomeOutlined,
    AppstoreOutlined,
    StarFilled,
    CloudUploadOutlined,
    DeleteOutlined,
    EyeOutlined,
    DownOutlined,
    SaveOutlined,
    LogoutOutlined,
    ToolOutlined,
    LoginOutlined,
    CloseCircleOutlined,
    PlusOutlined,
    CloseOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { Alert, Button, Card, DatePicker, Dropdown, Image, Popconfirm, Result, Space, TimePicker, Tooltip } from "antd";
import CheckOutModal from "./CheckOutModal";
import { currentDate, currentTime, formatDate } from "../../../components/Customs/dateFormatter";
import dayjs from "dayjs";
import { navigate } from "../../../components/Customs/navigation";
import { useLocation } from "react-router-dom";
import { BooknLogService } from "../../../Services/BooknLogService";
import { notify } from "../../../components/Customs/NotifyProvider";
import { ENDPOINTS } from "../../../Services/ENDPOINT";
import { styles } from "./Styles";
import { css, DEFAULT_CFG, STATUS_CONFIG, T } from "../../Styles/css";
import { DetailItem, SectionCard, StatusBadge } from "../../../components/Rooms/history/History";
import { RoomServices } from "../../../Services/RoomServices";
import maintance from "../../../../assets/room-maintance.jpg";
import CancleCheckModal from "./CancleCheckModal";
import ServiceRequestModal from "./ServiceRequestModal";
import { CheckInOutCard } from "./CheckInOutCard";
import { GeneralService } from "../../../Services/GeneralService";
import { UpcomingBookingsList } from "./UpcomingBookingsList";
import axios from "axios";
import generatePDF from "../../../components/Customs/generatePDF";
import generateA4PDF from "../../../components/Customs/generateA4PDF";

import { Empty } from "antd";
import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from "../../../../utils/permissionUtils";

const MODULE_KEY = "online_room_booking";

const { RangePicker } = DatePicker;

export default function OnlineBookRoom() {
    const location = useLocation();
    const room = location.state?.room;

    const isOnlineBookingView = location.state?.source === 'online_booking'; // ← add this
    const onlineBooking = location.state?.booking ?? null;                   // ← and this

    const cfg = STATUS_CONFIG[room.status?.toLowerCase()] || DEFAULT_CFG;
    let amenities = [];
    try {
        amenities = JSON.parse(room.amenities || "[]");
    } catch { }

    console.log("isOnlineBookingView", isOnlineBookingView);

    console.log("onlineBooking", onlineBooking?.bl_id);
    console.log("onlineBooking+++++++", onlineBooking);

    const todayDate = dayjs();
    const tomorrowDate = dayjs().add(1, "day");

    const [form, setForm] = useState({
        guest_name: "",
        phone: "",
        email: "",
        id_type: "Aadhaar",
        id_number: "",
        address: "",
        guests: 1,
        check_in: todayDate.format("YYYY-MM-DD"),
        check_out: tomorrowDate.format("YYYY-MM-DD"),
        special_requests: "",
        payment_mode: "Cash",
    });

    const [docs, setDocs] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const fileRef = useRef();
    const dropdownRef = useRef();

    const [docFiles, setDocFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [bookId, setBookId] = useState("");
    const [existingUser, setExistingUser] = useState(null);

    // ── Check-Out Modal state ──────────────────────────
    const [checkOutModalOpen, setCheckOutModalOpen] = useState(false);
    const [cancelCheckModalOpen, setCancelCheckModalOpen] = useState(false);
    const [serviceReqModalOpen, setServiceReqModalOpen] = useState(false);
    const [checkOutLoading, setCheckOutLoading] = useState(false);
    const [resevDate, setResvDate] = useState([]);
    const [isNewReservation, setIsNewReservation] = useState(false);
    const [allBookings, setAllBookings] = useState([]);
    const [selectedUpcoming, setSelectedUpcoming] = useState(null);
    const [acRequired, setAcRequired] = useState(true);
    const [headerImg, setHeaderImg] = useState('');
    const [gst, setGst] = useState('');
    const [defaultCheckInTime, setDefaultCheckInTime] = useState('');
    const [defaultCheckOutTime, setDefaultCheckOutTime] = useState('');

    const emptyForm = {
        guest_name: "",
        phone: "",
        email: "",
        id_type: "Aadhaar",
        id_number: "",
        address: "",
        guests: 1,
        check_in: todayDate.format("YYYY-MM-DD"),
        check_out: tomorrowDate.format("YYYY-MM-DD"),
        special_requests: "",
        payment_mode: "Cash",
    };

    const isFutureBooking = dayjs(form.check_in).isAfter(dayjs(), "day");



    // useEffect(() => {
    //     if (room.status !== "available") {
    //         const fetchOccData = async () => {
    //             try {
    //                 const response = await BooknLogService.getRoomOccData(room.id, room.status);
    //                 setExistingUser(response.data);
    //                 console.log(response.data);
    //             } catch (error) {
    //                 console.error(error);
    //             }
    //         };
    //         fetchOccData();
    //     }
    // }, [room.id, room.status]);

    useEffect(() => {
        // When opened from OnlineBookingPage, skip fetching the room's
        // current occupant — it would overwrite the online booking form data.
        if (isOnlineBookingView) return;

        if (room.status !== "available") {
            const fetchOccData = async () => {
                try {
                    const response = await BooknLogService.getRoomOccData(room.id, room.status);
                    setExistingUser(response.data);
                    setForm(response.data);

                    console.log("Existing occupant data:XXXXX", response.data);
                } catch (error) {
                    console.error(error);
                }
            };
            fetchOccData();
        }
    }, [room.id, room.status]);

    useEffect(() => {
        if (!isOnlineBookingView || !onlineBooking) return;

        console.log("xx", room);


        console.log("onlineBookingXXxxxxxxxxxxxxx", onlineBooking.bl_id);


        setForm({
            guest_name: onlineBooking.guest_name ?? '',
            phone: onlineBooking.phone ?? '',
            email: onlineBooking.email ?? '',
            id_type: onlineBooking.id_type ?? 'Aadhaar',
            id_number: onlineBooking.id_number ?? '',
            address: onlineBooking.address ?? '',
            guests: Number(onlineBooking.guests) || 1,
            check_in: onlineBooking.check_in ?? todayDate.format('YYYY-MM-DD'),
            check_out: onlineBooking.check_out ?? tomorrowDate.format('YYYY-MM-DD'),
            special_requests: onlineBooking.special_requests ?? '',
            payment_mode: onlineBooking.payment_mode ?? 'Cash',
            br_id: onlineBooking.id,
            bl_id: onlineBooking.bl_id,
            ac_required: onlineBooking.ac_required,
            ...onlineBooking

        });

        setAcRequired(onlineBooking.ac_required);

        // Load any documents that were uploaded with the online booking
        try {
            const paths = JSON.parse(onlineBooking.document_upload || '[]');
            const BASE = ENDPOINTS.cleanBase;
            setDocs(paths.map((p) => {
                const name = p.split('/').pop();
                const ext = name.split('.').pop().toLowerCase();
                const mime = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
                    ? `image/${ext === 'jpg' ? 'jpeg' : ext}`
                    : 'application/pdf';
                return { name, size: 'existing', type: mime, url: BASE + p, existing: true };
            }));
        } catch { setDocs([]); }
    }, [isOnlineBookingView]);        // runs once on mount

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                // setDropdownOpen(false); — removed unused state
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {
        if (existingUser?.length > 0) {
            const u = existingUser[0];
            console.log(")))))", existingUser);

            setForm({
                guest_name: u.guest_name || "",
                phone: u.phone || "",
                email: u.email || "",
                id_type: u.id_type || "Aadhaar",
                id_number: u.id_number || "",
                address: u.address || "",
                guests: Number(u.guests) || 1,
                check_in: u.check_in || todayDate.format("YYYY-MM-DD"),
                check_out: u.check_out || tomorrowDate.format("YYYY-MM-DD"),
                special_requests: u.special_requests || "",
                payment_mode: u.payment_mode || "Cash",
                ac_required: u.ac_required,
                ...u
            });

            setAcRequired(u.ac_required === "true" || u.ac_required === true);

            setPaidAmount(Number(u?.paid_amount) || 0);

            console.log("xxxxxxx", u);


            try {
                const uploadedPaths = JSON.parse(u.document_upload || "[]");
                const BASE_URL = ENDPOINTS.cleanBase;
                const mapped = uploadedPaths.map((path) => {
                    const fileName = path.split("/").pop();
                    const ext = fileName.split(".").pop().toLowerCase();
                    const mime = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext)
                        ? `image/${ext === "jpg" ? "jpeg" : ext}`
                        : "application/pdf";
                    return {
                        name: fileName,
                        size: "existing",
                        type: mime,
                        url: BASE_URL + path,
                        existing: true,
                    };
                });
                setDocs(mapped);
            } catch (err) {
                console.error("Failed to parse document_upload:", err);
            }
        }
    }, [existingUser]);

    useEffect(() => {
        getCheckTime();
    }, [])

    const getCheckTime = async () => {
        try {

            const req = await RoomServices.getAllByTable('utills')

            const defaultData = {
                checkin: dayjs(req.data[0].checkin_time, 'hh:mm A'),
                checkout: dayjs(req.data[0].checkout_time, 'hh:mm A'),
            }
            setDefaultCheckInTime(dayjs(req.data[0].checkin_time, 'hh:mm A'))
            setDefaultCheckOutTime(dayjs(req.data[0].checkout_time, 'hh:mm A'))

            setHeaderImg(req.data[0]?.header_img)
            setGst(req.data[0]?.gst)
            console.log("req.data[0]?.gst", req.data[0]?.gst);


        } catch (error) {
            console.error(error);

        }
    }

    const getReservedDate = async () => {
        try {
            const req = await GeneralService.getReservationData('book_log', room.id)
            console.log(req.data);
            setResvDate(req.data);

            console.log("room-id", room.id);


        } catch (error) {
            console.error(error);

        }
    }

    const fetchAllBookings = async () => {
        try {
            const res = await axios.get(`${ENDPOINTS.BOOKROOM}?id=${room.id}&status=all`);

            console.log(`${ENDPOINTS.BOOKROOM}?id=${room.id}&status=all`);

            setAllBookings(res.data?.data || []);

            console.log("fetchAllBookings", res.data);

        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        if (isOnlineBookingView) return;
        fetchAllBookings()
        getReservedDate()
    }, [room.id])


    const reservedRanges = resevDate.map(r => ({
        start: dayjs(r.check_in),
        end: dayjs(r.check_out)
    }));



    const handleUpcomingSelect = (booking) => {
        if (selectedUpcoming?.bl_id === booking.bl_id) {
            // Deselect — restore original existing user
            setSelectedUpcoming(null);
            if (existingUser?.length > 0) {
                const u = existingUser[0];
                setForm({ ...emptyForm, ...u, guests: Number(u.guests) || 1 });
            } else {
                setForm(emptyForm);
            }
            setIsNewReservation(false);
            return;
        }

        setSelectedUpcoming(booking);
        setIsNewReservation(true);


        // Populate form with this upcoming booking's data
        setForm({
            guest_name: booking.guest_name || "",
            phone: booking.phone || "",
            email: booking.email || "",
            id_type: booking.id_type || "Aadhaar",
            id_number: booking.id_number || "",
            address: booking.address || "",
            guests: Number(booking.guests) || 1,
            check_in: dayjs(booking.check_in).format("YYYY-MM-DD"),
            check_out: dayjs(booking.check_out).format("YYYY-MM-DD"),
            special_requests: booking.special_requests || "",
            payment_mode: booking.payment_mode || "Cash",
            ac_required: booking.ac_required,
        });

        // Load docs if any
        try {
            const paths = JSON.parse(booking.document_upload || "[]");
            const BASE = ENDPOINTS.cleanBase;
            setDocs(paths.map((p) => {
                const name = p.split("/").pop();
                const ext = name.split(".").pop().toLowerCase();
                const mime = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext)
                    ? `image/${ext === "jpg" ? "jpeg" : ext}`
                    : "application/pdf";
                return { name, size: "existing", type: mime, url: BASE + p, existing: true };
            }));
        } catch { setDocs([]); }

        setErrors({});
        setDocFiles([]);
    };

    const items = [
        {
            key: "occupied",
            label: (
                <span style={{ color: "green" }}>
                    <CheckCircleOutlined style={{ marginRight: 7, fontSize: 20 }} />{" "}
                    Confirm Booking
                </span>
            ),
            disabled: isFutureBooking,
        },
        {
            key: "reserved",
            label: (
                <span style={{ color: "red" }}>
                    <CalendarOutlined style={{ marginRight: 7, fontSize: 20 }} /> Reserve Room
                </span>
            ),
        },
    ];

    const handleMenuClick = ({ key }) => {
        handleSubmit(key);
    };

    const onBack = () => {
        navigate(-1);
    };

    const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

    const nights = (() => {
        if (!form.check_in || !form.check_out) return 0;
        const d = (new Date(form.check_out) - new Date(form.check_in)) / 86400000;
        return d > 0 ? d : 1;
    })();

    const max_persona = Number(room.max_occupancy || 0) + Number(room.additional_occupancy || 0);

    console.log("max_persona", max_persona);

    const extraGuests = Math.max(0, (form.guests || 1) - (room.max_occupancy || 0));
    const extraCostPerNight = extraGuests * (room.add_cost_per_occupancy || 0);
    // const baseTotal = nights * (room.price_per_day || 0);
    // const extraTotal = nights * extraCostPerNight;
    // const total = baseTotal + extraTotal;


    const baseTotal = nights * (room.price_per_day || 0);
    const extraTotal = nights * extraCostPerNight;
    const acChargeTotal = acRequired ? (room.ac_charge || 0) * nights : 0;
    const total = baseTotal + extraTotal + acChargeTotal;


    const [paidAmount, setPaidAmount] = useState(total);

    useEffect(() => {
        let calculatedTotal = baseTotal + extraTotal;
        if (acRequired) {
            calculatedTotal += Number(room.ac_charge || 0);
        }
        setPaidAmount(calculatedTotal);
    }, [baseTotal, extraTotal, acRequired, room.ac_charge]);


    useEffect(() => {
        setPaidAmount(total);
    }, [total]);

    const handleFiles = (e) => {
        const files = Array.from(e.target.files || []);
        setDocFiles((p) => [...p, ...files]);
        const mapped = files.map((f) => ({
            name: f.name,
            size: (f.size / 1024).toFixed(1) + " KB",
            type: f.type,
            url: URL.createObjectURL(f),
        }));
        setDocs((p) => [...p, ...mapped]);
        fileRef.current.value = "";
    };

    const removeDoc = async (i) => {
        console.log("Removed doc:", docs[i].name);
        setDocs((p) => p.filter((_, idx) => idx !== i));
        setDocFiles((p) => p.filter((_, idx) => idx !== i));
    };

    // Replace your current validate() function with this:

    const validate = (type = null) => {
        const e = {};

        // Skip guest detail validation for reservation
        const isReservation = type === "reserved";

        if (!isReservation) {
            if (!form.guest_name.trim()) e.guest_name = "Required";
            if (!form.phone.trim()) e.phone = "Required";
            if (!form.id_number.trim()) e.id_number = "Required";
        }

        // Date validation always required
        if (!form.check_in) e.date_range = "Required";
        if (!form.check_out) e.date_range = "Required";

        if (nights <= 0 && form.check_out) {
            e.date_range = "Check-out must be after check-in";
        }

        return e;
    };

    const buildFormData = (payload, docFiles = []) => {
        const formData = new FormData();
        const appendValue = (key, value) => {
            if (value === null || value === undefined) return;
            if (typeof value === "object" && !(value instanceof File)) {
                formData.append(key, JSON.stringify(value));
            } else {
                formData.append(key, value);
            }
        };
        Object.entries(payload).forEach(([key, value]) => appendValue(key, value));
        docFiles.forEach((file) => formData.append("documents", file));
        return formData;
    };

    const handleSubmit = async (type) => {
        console.log("Submitting with type:", type);

        const currentTime = dayjs().format("hh:mm:ss A");

        const pricing_summary = {
            rate_per_night: room.price_per_day || 0,
            duration_nights: nights,
            base_total: baseTotal,
            extra_guests: extraGuests,
            extra_cost_per_night: extraCostPerNight,
            extra_total: extraTotal,
            total_amount: total,
            paid_amount: paidAmount,
        };
        console.log('form', form);
        console.log("form.guest_name", form.guest_name);
        console.log("form.phone", form.phone);

        if (type === "occupied") {
            if (!form?.guest_name?.trim()) {
                notify.error(
                    "Guest name is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }

            if (!form?.phone?.trim()) {
                notify.error(
                    "Phone number is required for confirming booking. For reservations, you can confirm later."
                );
                return;
            }
        }

        console.log("***", form);


        const finalPayload = {
            ...form,
            room_id: room.id,
            ac_required: acRequired,
            room_data: room,
            check_in_time: currentTime,
            check_out_time: currentTime,
            pricing_summary,
            status: type,
            paid_amount: paidAmount,
            // KEY: if this is a future reservation on an already-occupied room,
            // tell the backend NOT to change the room's current status
            // skip_room_status_update: isNewReservation ? true : false,
            skip_room_status_update: !isOnlineBookingView && isNewReservation,
        };

        const formData = buildFormData({ ...finalPayload }, docFiles);

        console.log("finalPayload__--", finalPayload);


        try {
            setLoading(true);
            const res = await fetch(ENDPOINTS.BOOKROOM, { method: "POST", body: formData });
            const data = await res.json();
            if (data.status) {
                setIsNewReservation(false); // reset mode
                setSubmitted(true);
                setBookId(data.book_room_id);
            } else {
                alert("Booking failed: " + data.message);
            }
        } catch (err) {
            alert("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdate = async () => {
        // const e = validate();
        // if (Object.keys(e).length) { setErrors(e); return; }

        const currentTimeStr = dayjs().format("hh:mm:ss A");
        const pricing_summary = {
            rate_per_night: room.price_per_day || 0,
            duration_nights: nights,
            base_total: baseTotal,
            extra_guests: extraGuests,
            extra_cost_per_night: extraCostPerNight,
            extra_total: extraTotal,
            total_amount: total,
            ac_charge_total: acRequired ? (room.ac_charge || 0) * nights : 0,
            ac_charge: acRequired ? room.ac_charge || 0 : 0,
            paid_amount: paidAmount,

        };

        console.log("form", form);


        const existing_documents = docs
            .filter((d) => d.existing)
            .map((d) => `documents/${d.name}`);

        // Use selectedUpcoming if editing an upcoming booking, else use existingUser[0]
        // const sourceData = selectedUpcoming || existingUser?.[0] || {};
        const sourceData = selectedUpcoming || existingUser?.[0] || onlineBooking || {};

        console.log("00000", form);


        const finalPayload = {
            ...form,
            ac_required: acRequired,
            book_room_id: sourceData.id || sourceData.book_room_id,
            book_log_id: sourceData.bl_id || sourceData.id,
            room_id: room.id,
            room_data: room,
            pricing_summary,
            status: sourceData.status || room.status,
            existing_documents,
            paid_amount: paidAmount,
        };

        const formData = buildFormData(finalPayload, docFiles);

        console.log("finalPayload@@@@", finalPayload);

        try {
            setLoading(true);
            const res = await fetch(ENDPOINTS.BOOKROOM, { method: "PATCH", body: formData });
            const data = await res.json();
            if (data.status) {

                const submittedForm = { ...form };

                notify.success("Booking updated successfully!");
                // Refresh upcoming list
                fetchAllBookings();
                // If was editing upcoming, deselect and reset
                if (selectedUpcoming) {
                    setSelectedUpcoming(null);
                    setIsNewReservation(false);
                    if (existingUser?.length > 0) {
                        const u = existingUser[0];
                        setForm({ ...emptyForm, ...u, guests: Number(u.guests) || 1 });
                    }
                } else {
                    setSubmitted(true);
                    setBookId(data.book_room_id);

                }
                setForm(submittedForm);
                setSubmitted(true);
                setBookId(data.book_room_id);
            } else {
                notify.error("Update failed: " + data.message);
            }
        } catch (err) {
            notify.error("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };
    // ── Check-Out handler: receives { status, note } from modal ──
    const handleCheckOut = async ({ status, note, form }) => {
        const log = { status, note };
        console.log("Check-out log:", log);
        console.log("Check-out form:", form);

        try {
            setCheckOutLoading(true);
            const paylaod = {
                guest_status: status,
                note: note,
                status: 'available',

                bl_id: form.bl_id,
                br_id: form.br_id,
                room_id: form.room_id,

                act_check_out_date: currentDate(),
                act_check_out_time: currentTime(),
                update_at: formatDate(),

            }
            console.log("payload", paylaod);

            const res = await BooknLogService.checkOut(paylaod);

            console.log("res for checkout", res);

            if (res.status) {
                notify.success(res.message);
                setCheckOutModalOpen(false);
                navigate(-1);
            } else {
                notify.error(res.message || "Check-out failed");
            }
        } catch (err) {
            notify.error("Something went wrong.");
        } finally {
            setCheckOutLoading(false);
        }

        // For now just close modal and notify
        setCheckOutModalOpen(false);
        notify.success("Check-out logged successfully!");
    };

    const handleMaintenance = async (status) => {
        try {
            const request = await RoomServices.editRoom(room.id, { status: status });
            if (request.status) {
                notify.success(`Room marked as ${status}`);
                navigate('/book-room')
            } else {
                notify.error(`Failed to mark room as ${status}.`);
            }

        } catch (error) {
            console.error(error);
            notify.error("Something went wrong.");
        }
    }

    const grandTotal = total;
    const totalPaid = paidAmount;

    if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    if (submitted)


        return (
            <SuccessScreen
                // form={}
                bookId={bookId}
                room={room}
                form={form || onlineBooking}
                nights={nights}
                total={total}

                grandTotal={total}        // ← add this
                paidAmount={paidAmount}
                //         grandTotal={grandTotal}
                // paidAmount={totalPaid}
                onBack={onBack}
                headerImg={`${ENDPOINTS.IMG_HEADER}${headerImg}`}
                gst={gst}
            />
        );

    return (
        <>
            <Card

                title={

                    <div style={{ ...css.cardHeader, padding: '15px 0 15px 0' }}>
                        <div
                            style={css.backBtn}
                            onClick={() => navigate(-1)}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = T.accentSoft;
                                e.currentTarget.style.transform = "scale(1.06)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = T.accentLight;
                                e.currentTarget.style.transform = "scale(1)";
                            }}
                        >
                            <ArrowLeftOutlined />
                        </div>
                        <div>
                            <div style={css.pageTitle}>Online Room Booking</div>
                            <div style={{ fontSize: 11, color: T.textMuted, marginTop: 1 }}>
                                Manage booking & reservation of room
                            </div>
                        </div>
                    </div>
                }
                extra={
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>

                        {room.status === "occupied" && (
                            <>
                                <Button
                                    onClick={() => setServiceReqModalOpen(true)}
                                    type="primary" size="middle">Service Request</Button>
                            </>
                        )}

                        <Divider type="vertical" style={{ borderColor: T.border }} />
                        {room.status === "available" && (
                            <Popconfirm
                                title="Mark as Maintenance"
                                description="This room is under maintenance. Are you sure?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    console.log("Confirmed");
                                    handleMaintenance('maintenance');
                                }}
                            >
                                <Button
                                    danger
                                    icon={<ToolOutlined style={{ fontSize: 20, color: "red" }} />}
                                >
                                    Maintenance
                                </Button>
                            </Popconfirm>
                        )}

                    </div>
                }
            >
                <div style={styles.layout}>
                    {/* ══════ LEFT — Room Details ══════ */}
                    <div style={styles.leftPanel}>

                        <SectionCard title="Room Details" icon={<HomeOutlined />}
                            extra={
                                <Button
                                    onClick={() => navigate('/room/history', { state: { room } })}


                                    color="purple" variant="text">
                                    History
                                </Button>
                            }
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
                                <div>
                                    <div style={{ fontSize: 20, fontWeight: 700, color: T.text, letterSpacing: "-0.5px" }}>{room?.room_name}</div>
                                    <div style={{ fontSize: 12, color: T.textMuted, marginTop: 2 }}>Room #{room?.room_number}</div>
                                </div>
                                <StatusBadge cfg={cfg} />
                            </div>

                            {room?.description && (
                                <div
                                    style={{
                                        fontSize: 12.5, color: T.textSub, lineHeight: 1.65,
                                        padding: "10px 12px", background: T.bg,
                                        borderRadius: T.radiusSm, border: `1px solid ${T.border}`,
                                        marginBottom: 14, wordBreak: "break-word",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: room.description }}
                                />
                            )}

                            <div style={{ height: 1, background: T.border, margin: "14px 0" }} />

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 4 }}>
                                <DetailItem icon={<AppstoreOutlined />} label="Room Type" value={room?.room_type} />
                                <DetailItem icon={<TeamOutlined />} label="Max Occupancy" value={room?.max_occupancy ? `${room.max_occupancy} guests` : "—"} />
                                <DetailItem icon={<HomeOutlined />} label="Floor" value={room?.floor} />
                                <DetailItem icon={<StarFilled />} label="Status" value={room?.status} />
                            </div>

                            <Divider />
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 8 }}>Amenities</div>
                            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                {amenities.map((a) => (<span key={a} style={styles.amenityTag}>{a}</span>))}
                            </div>

                            <Divider />
                            <div style={{ fontSize: 11, fontWeight: 600, color: "#888", textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 10 }}>Pricing Summary</div>

                            {/* <div style={styles.priceRow}>
                                <span>Rate per night</span>
                                <span style={{ fontWeight: 600 }}>₹{room.price_per_day?.toLocaleString()}</span>
                            </div> */}

                            <div style={styles.priceRow}>
                                <span>Rate per night</span>
                                <span style={{ fontWeight: 600 }}>
                                    ₹{(onlineBooking
                                        ? JSON.parse(onlineBooking.pricing_summary).rate_per_night
                                        : room.price_per_day
                                    )?.toLocaleString()}
                                </span>
                            </div>


                            {/* <div style={styles.priceRow}>
                                <span>Duration</span>
                                <span style={{ fontWeight: 600 }}>{nights || "—"} {nights === 1 ? "night" : "nights"}</span>
                            </div> */}

                            <div style={styles.priceRow}>
                                <span>Duration</span>
                                <span style={{ fontWeight: 600 }}>
                                    {onlineBooking
                                        ? (() => {
                                            const ps = JSON.parse(onlineBooking.pricing_summary);
                                            const n = ps.duration_nights;
                                            return `${n} ${n === 1 ? "night" : "nights"}`;
                                        })()
                                        : `${nights || "—"} ${nights === 1 ? "night" : "nights"}`
                                    }
                                </span>
                            </div>

                            {onlineBooking && (
                                <div style={styles.priceRow}>
                                    <span>Base Total</span>
                                    <span style={{ fontWeight: 600 }}>
                                        ₹{JSON.parse(onlineBooking.pricing_summary).base_total?.toLocaleString()}
                                    </span>
                                </div>
                            )}

                            {/* <div style={styles.priceRow}>
                                <span>
                                    AC Charge{" "}
                                    <Tooltip title="Only added if AC service is selected">
                                        <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }} />
                                    </Tooltip>
                                </span>
                                <span style={{ fontWeight: 600 }}>₹{room.ac_charge?.toLocaleString()}</span>
                            </div> */}
                            {/* {room.ac_charge > 0 && (
                                <div style={styles.priceRow}>
                                    <span>
                                        AC Charge{" "}
                                        <Tooltip title="Check 'AC Required' in booking details to add this charge">
                                            <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                    <span style={{ fontWeight: 600, color: acRequired ? "#237804" : "#999" }}>
                                        ₹{room.ac_charge?.toLocaleString()} / Duration
                                        {!acRequired && " (optional)"}
                                    </span>
                                </div>
                            )}


                            {extraGuests > 0 && (
                                <>
                                    <div style={styles.priceRow}>
                                        <span>Extra Guests ({extraGuests})</span>
                                        <span style={{ fontWeight: 600 }}>₹{extraCostPerNight.toLocaleString()} / night</span>
                                    </div>
                                    <div style={styles.priceRow}>
                                        <span>Extra Guest Total</span>
                                        <span style={{ fontWeight: 600 }}>₹{extraTotal.toLocaleString()}</span>
                                    </div>
                                </>
                            )} */}
                            {/* <div style={{ ...styles.priceRow, marginTop: 10, padding: "10px 14px", background: "#f6ffed", borderRadius: 8, border: "1px solid #b7eb8f" }}>
                                <span style={{ fontWeight: 700, color: "#237804" }}>Total Amount</span>
                                <span style={{ fontWeight: 800, fontSize: 18, color: "#237804" }}>₹{total.toLocaleString()}</span>
                            </div> */}
                            {/* {form.ac_require === "true" && acRequired && room.ac_charge > 0 && (
                                <div style={styles.priceRow}>
                                    <span>AC Charge Total</span>
                                    <span style={{ fontWeight: 600 }}>₹{acChargeTotal.toLocaleString()}</span>
                                </div>
                            )}

                            <div style={{ ...styles.priceRow, marginTop: 10, padding: "10px 14px", background: "#f6ffed", borderRadius: 8, border: "1px solid #b7eb8f" }}>
                                <span style={{ fontWeight: 700, color: "#237804" }}>Total Amount</span>
                                <span style={{ fontWeight: 800, fontSize: 18, color: "#237804" }}>₹{total.toLocaleString()}</span>
                            </div> */}

                            {room.ac_charge > 0 && (
                                <div style={styles.priceRow}>
                                    <span>
                                        AC Charge{" "}
                                        <Tooltip title="Check 'AC Required' in booking details to add this charge">
                                            <InfoCircleOutlined style={{ marginLeft: 6, color: "#1890ff", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                    <span style={{ fontWeight: 600, color: acRequired ? "#237804" : "#999" }}>
                                        {onlineBooking
                                            ? `₹${JSON.parse(onlineBooking.pricing_summary).ac_charge_per_night?.toLocaleString()} / night`
                                            : `₹${room.ac_charge?.toLocaleString()} / Duration`
                                        }
                                        {!acRequired && " (optional)"}
                                    </span>
                                </div>
                            )}

                            {/* AC Total — only show for online booking */}
                            {onlineBooking && acRequired && (
                                <div style={styles.priceRow}>
                                    <span>AC Total</span>
                                    <span style={{ fontWeight: 600 }}>
                                        ₹{JSON.parse(onlineBooking.pricing_summary).ac_total?.toLocaleString()}
                                    </span>
                                </div>
                            )}

                            {/* Extra Guests */}
                            {(onlineBooking
                                ? JSON.parse(onlineBooking.pricing_summary).extra_guests > 0
                                : extraGuests > 0
                            ) && (
                                    <>
                                        <div style={styles.priceRow}>
                                            <span>
                                                Extra Guests ({onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_guests
                                                    : extraGuests})
                                            </span>
                                            <span style={{ fontWeight: 600 }}>
                                                ₹{(onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_cost_per_night
                                                    : extraCostPerNight
                                                )?.toLocaleString()} / night
                                            </span>
                                        </div>
                                        <div style={styles.priceRow}>
                                            <span>Extra Guest Total</span>
                                            <span style={{ fontWeight: 600 }}>
                                                ₹{(onlineBooking
                                                    ? JSON.parse(onlineBooking.pricing_summary).extra_total
                                                    : extraTotal
                                                )?.toLocaleString()}
                                            </span>
                                        </div>
                                    </>
                                )}

                            {/* Total Amount */}
                            <div style={{ ...styles.priceRow, marginTop: 10, padding: "10px 14px", background: "#f6ffed", borderRadius: 8, border: "1px solid #b7eb8f" }}>
                                <span style={{ fontWeight: 700, color: "#237804" }}>Total Paid Amount</span>
                                <span style={{ fontWeight: 800, fontSize: 18, color: "#237804" }}>
                                    ₹{(onlineBooking
                                        ? JSON.parse(onlineBooking.pricing_summary).total_amount
                                        : total
                                    )?.toLocaleString()}
                                </span>
                            </div>

                            {/* <div
                                style={{
                                    ...styles.priceRow,
                                    marginTop: 10,
                                    padding: "10px 14px",
                                    background: "#f6ffed",
                                    borderRadius: 8,
                                    border: "1px solid #b7eb8f",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <span style={{ fontWeight: 700, color: "#237804" }}>
                                    Paid Amount
                                </span>

                                <input
                                    type="number"
                                    size='large'
                                    value={paidAmount}
                                    // disabled={existingUser?.length > 0}
                                    onChange={(e) => setPaidAmount(Number(e.target.value))}
                                    style={{
                                        fontWeight: 800,
                                        fontSize: 18,
                                        color: "#237804",
                                        border: "1px solid #b7eb8f",
                                        borderRadius: 6,
                                        padding: "4px 8px",
                                        width: 140,
                                        textAlign: "right",
                                        background: "#fff",
                                        outline: "none",
                                    }}
                                />
                            </div> */}

                            <UpcomingBookingsList
                                bookings={allBookings}
                                onSelect={handleUpcomingSelect}
                                selectedId={selectedUpcoming?.bl_id}
                            />

                        </SectionCard>
                    </div>

                    {/* ══════ RIGHT — Booking Form ══════ */}
                    <div style={styles.rightPanel}>

                        {room.status === "maintenance" ? (<>

                            <Result
                                icon={
                                    <Image
                                        src={maintance}
                                        preview={false}
                                        alt="Room Maintenance"
                                        style={{ width: "70%", height: "auto" }}
                                    />
                                }
                                title="Room under maintenance!"
                                extra={

                                    <Popconfirm
                                        title="Mark as Available"
                                        description="This room will be marked as available. Are you sure?"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => {
                                            handleMaintenance('available');
                                        }}
                                    >
                                        <Button size="large" color="pink" variant="filled">
                                            Make it Available
                                        </Button>
                                    </Popconfirm>

                                }
                            />
                        </>) : (<>

                            <SectionCard
                                title={<Space>
                                    Guest Information

                                </Space>}
                                icon={<UserOutlined />}
                                // extra={
                                //     <Space>
                                //         {room.status === "reserved" && (

                                //             <Space>

                                //                 <Button
                                //                     size="large"
                                //                     icon={<CloseCircleOutlined />}
                                //                     onClick={() => setCancelCheckModalOpen(true)}
                                //                     color="purple" variant="filled"

                                //                 >Cancle Reservation</Button>

                                //                 <Button
                                //                     color="primary"
                                //                     variant="filled"
                                //                     icon={<LoginOutlined />}
                                //                     size="large"
                                //                     onClick={() => handleSubmit("occupied")}
                                //                 >Check-In</Button>

                                //             </Space>

                                //         )}

                                //         {existingUser?.length > 0 && (
                                //             <Button
                                //                 size="large"
                                //                 color="danger"
                                //                 variant="filled"
                                //                 icon={<LogoutOutlined />}
                                //                 onClick={() => setCheckOutModalOpen(true)}
                                //             >
                                //                 Check Out
                                //             </Button>
                                //         )}
                                //     </Space>
                                // }
                                extra={
                                    <Space>
                                        {room.status?.toLowerCase() != "available" && (
                                            <>
                                                {/* Show New Reservation only if existing user is present */}
                                                {existingUser?.length > 0 && (
                                                    <Button
                                                        size="large"
                                                        icon={isNewReservation ? <CloseOutlined /> : <PlusOutlined />}
                                                        onClick={() => {
                                                            if (isNewReservation) {
                                                                // Cancel — restore existing guest form
                                                                setIsNewReservation(false);
                                                                const u = existingUser[0];
                                                                setForm({
                                                                    ...emptyForm,
                                                                    ...u,
                                                                    guests: Number(u.guests) || 1,
                                                                });
                                                            } else {
                                                                // Switch to blank new-reservation form
                                                                setIsNewReservation(true);
                                                                setForm({
                                                                    ...emptyForm,
                                                                    check_in: tomorrowDate.format("YYYY-MM-DD"),
                                                                    check_out: tomorrowDate
                                                                        .add(1, "day")
                                                                        .format("YYYY-MM-DD"),
                                                                });
                                                                setDocs([]);
                                                                setDocFiles([]);
                                                                setErrors({});
                                                            }
                                                        }}
                                                        color={isNewReservation ? "default" : "primary"}
                                                        variant="filled"
                                                    >
                                                        {isNewReservation ? "Close" : "New Reservation"}
                                                    </Button>
                                                )}

                                                <Space>
                                                    <Tooltip title={!canUpdateModule(MODULE_KEY) ? "No permission to Cancel Reservation" : ""}>
                                                        <Button
                                                            size="large"
                                                            icon={<CloseCircleOutlined />}
                                                            onClick={() => setCancelCheckModalOpen(true)}
                                                            color="purple"
                                                            variant="filled"
                                                            disabled={!canUpdateModule(MODULE_KEY)}
                                                        >
                                                            Cancel Reservation
                                                        </Button>
                                                    </Tooltip>

                                                    <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to Check-In" : ""}>
                                                        <Button
                                                            color="primary"
                                                            variant="filled"
                                                            icon={<LoginOutlined />}
                                                            size="large"
                                                            disabled={!canCreateModule(MODULE_KEY)}
                                                            onClick={() => handleSubmit("occupied")}
                                                        >
                                                            Check-In
                                                        </Button>
                                                    </Tooltip>
                                                </Space>

                                                <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to Check Out" : ""}>
                                                    <Button
                                                        size="large"
                                                        color="danger"
                                                        variant="filled"
                                                        icon={<LogoutOutlined />}
                                                        disabled={!canCreateModule(MODULE_KEY)}  // ← same as Check-In
                                                        onClick={() => setCheckOutModalOpen(true)}
                                                    >
                                                        Check Out
                                                    </Button>
                                                </Tooltip>
                                            </>
                                        )}
                                    </Space>
                                }
                            >
                                {existingUser?.length > 0 && !isNewReservation && (
                                    <>
                                        <CheckInOutCard form={form} />
                                        <Divider style={{ margin: "14px 0" }} />
                                    </>
                                )}

                                {isNewReservation && (
                                    <div style={{
                                        background: "#e6f4ff",
                                        border: "1px solid #91caff",
                                        borderRadius: 8,
                                        padding: "10px 14px",
                                        marginBottom: 14,
                                        fontSize: 13,
                                        color: "#0050b3",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                    }}>
                                        <CalendarOutlined style={{ fontSize: 16 }} />
                                        You are creating a <strong>new future reservation</strong>.
                                        The current guest is still checked in. Pick a future date range below.
                                    </div>
                                )}

                                <div style={{ ...styles.formGrid, gridTemplateColumns: "1fr 1fr" }}>

                                    <FormField label="Full Name" span={2}>
                                        <Input prefix={<UserOutlined />} placeholder="e.g. Ravi Kumar" value={form.guest_name}
                                            onChange={(v) => { set("guest_name", v); }} />
                                    </FormField>

                                    <FormField label="Phone Number" >
                                        <Input prefix={<PhoneOutlined />} placeholder="+91 XXXXX XXXXX" value={form.phone}
                                            onChange={(v) => { set("phone", v); }} />
                                    </FormField>
                                    <FormField label="Email Address">
                                        <Input prefix={<MailOutlined />} placeholder="email@example.com" value={form.email} onChange={(v) => set("email", v)} />
                                    </FormField>
                                    <FormField label="ID Type">
                                        <Select value={form.id_type} options={["Aadhaar", "Passport", "Driving License", "Voter ID", "PAN Card"]} onChange={(v) => set("id_type", v)} />
                                    </FormField>
                                    <FormField label="ID Number" >
                                        <Input prefix={<IdcardOutlined />} placeholder="Enter ID number" value={form.id_number}
                                            onChange={(v) => { set("id_number", v); setErrors((p) => ({ ...p, id_number: "" })); }} />
                                    </FormField>
                                    <FormField label="Address" span={2}>
                                        <Textarea placeholder="Full address of the guest" value={form.address} onChange={(v) => set("address", v)} rows={2} />
                                    </FormField>
                                </div>
                            </SectionCard>

                            <SectionCard title="Booking Details" icon={<CalendarOutlined />}
                                extra={
                                    <FormField label=" " span={1}>
                                        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginTop: 8 }}>
                                            <input
                                                type="checkbox"
                                                checked={acRequired}
                                                onChange={(e) => setAcRequired(e.target.checked)}
                                                style={{ width: 16, height: 16, cursor: "pointer" }}
                                            />
                                            <span style={{ fontSize: 13, fontWeight: 500 }}>AC Required</span>
                                            {room.ac_charge > 0 && (
                                                <span style={{ fontSize: 12, color: "#888" }}>(+₹{room.ac_charge}/stay)</span>
                                            )}
                                        </label>
                                    </FormField>
                                }
                            >
                                <div style={{ ...styles.formGrid, gridTemplateColumns: "2fr 1fr 1fr" }}>
                                    <FormField label={`Stay Duration ${nights ? `(${nights} ${nights === 1 ? "night" : "nights"})` : ""}`} required error={errors.date_range} span={1}>
                                        {/* <RangePicker
                                            style={{ width: "100%", height: 38 }}
                                            value={
                                                form.check_in && form.check_out
                                                    ? [dayjs(form.check_in), dayjs(form.check_out)]
                                                    : null
                                            }
                                            onChange={(dates, dateStrings) => {
                                                const [checkIn, checkOut] = dateStrings;
                                                setForm((p) => ({ ...p, check_in: checkIn, check_out: checkOut }));
                                                setErrors((p) => ({ ...p, date_range: "" }));
                                            }}
                                            disabledDate={(current) => {
                                                if (!current) return false;
                                                if (current < dayjs().startOf("day")) return true;
                                                // For new reservation on occupied room, also block the current occupancy range
                                                if (isNewReservation && existingUser?.length > 0) {
                                                    const u = existingUser[0];
                                                    const occStart = dayjs(u.check_in);
                                                    const occEnd = dayjs(u.check_out);
                                                    if (current.isBetween(occStart, occEnd, "day", "[]")) return true;
                                                }
                                                return reservedRanges.some(({ start, end }) =>
                                                    current.isBetween(start, end, "day", "[]")
                                                );
                                            }}
                                            format="YYYY-MM-DD"
                                            allowClear
                                        /> */}
                                        <RangePicker
  style={{ width: "100%", height: 38 }}
  value={
    form.check_in && form.check_out
      ? [dayjs(form.check_in), dayjs(form.check_out)]
      : null
  }
  onChange={(dates, dateStrings) => {
    const [checkIn, checkOut] = dateStrings;

    setForm((p) => ({
      ...p,
      check_in: checkIn,   // stored as YYYY-MM-DD
      check_out: checkOut, // stored as YYYY-MM-DD
    }));

    setErrors((p) => ({ ...p, date_range: "" }));
  }}
  disabledDate={(current) => {
    if (!current) return false;

    if (current < dayjs().startOf("day")) return true;

    // For new reservation on occupied room, also block the current occupancy range
    if (isNewReservation && existingUser?.length > 0) {
      const u = existingUser[0];
      const occStart = dayjs(u.check_in);
      const occEnd = dayjs(u.check_out);

      if (current.isBetween(occStart, occEnd, "day", "[]"))
        return true;
    }

    return reservedRanges.some(({ start, end }) =>
      current.isBetween(start, end, "day", "[]")
    );
  }}
  format="DD-MM-YYYY" // display format
  valueFormat="YYYY-MM-DD" // stored value format
  allowClear
/>
                                    </FormField>


                                    <FormField label="Check-in Time" span={1}>
                                        <TimePicker
                                            style={{ width: "100%", height: 38 }}
                                            format="hh:mm A"
                                            use12Hours
                                            value={form.check_in_time ? dayjs(form.check_in_time, "hh:mm A") : null}
                                            onChange={(time, timeString) => set("check_in_time", timeString)}
                                            allowClear
                                        />
                                    </FormField>

                                    <FormField label="Check-out Time" span={1}>
                                        <TimePicker
                                            style={{ width: "100%", height: 38 }}
                                            format="hh:mm A"
                                            use12Hours
                                            value={form.check_out_time ? dayjs(form.check_out_time, "hh:mm A") : null}
                                            onChange={(time, timeString) => set("check_out_time", timeString)}
                                            allowClear
                                        />
                                    </FormField>



                                    <FormField label="Number of Guests" span={1}>
                                        <NumberInput value={form.guests} min={1}
                                            max={max_persona}
                                            onChange={(v) => set("guests", v)} />
                                    </FormField>

                                    <FormField label="Payment Mode" span={1}>
                                        <Select value={form.payment_mode} options={["Cash", "UPI", "Card", "Bank Transfer", "Advance"]} onChange={(v) => set("payment_mode", v)} />
                                    </FormField>
                                    <FormField label="Special Requests" span={3}>
                                        <Textarea placeholder="Any special requirements, preferences or notes…" value={form.special_requests} onChange={(v) => set("special_requests", v)} rows={3} />
                                    </FormField>
                                </div>
                            </SectionCard>

                            <SectionCard

                                title="Document Upload" icon={<FileTextOutlined />}>
                                <p style={{ fontSize: 12.5, color: "#666", margin: "0 0 14px", lineHeight: 1.6 }}>
                                    Upload a copy of the guest's ID proof (Aadhaar, Passport, etc.). Accepted formats: JPG, PNG, PDF.
                                </p>
                                <div
                                    style={styles.dropZone}
                                    onClick={() => fileRef.current.click()}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => { e.preventDefault(); handleFiles({ target: { files: e.dataTransfer.files } }); }}
                                >
                                    <CloudUploadOutlined style={{ fontSize: 32, color: "#1677ff", marginBottom: 8 }} />
                                    <div style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Click or drag files here</div>
                                    <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>JPG, PNG, PDF · Max 10MB each</div>
                                    <input ref={fileRef} type="file" multiple accept=".jpg,.jpeg,.png,.pdf" style={{ display: "none" }} onChange={handleFiles} />
                                </div>

                                {docs.length > 0 && (
                                    <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 8 }}>
                                        {docs.map((d, i) => (
                                            <div key={i} style={styles.docItem}>
                                                <FileTextOutlined style={{ fontSize: 18, color: "#1677ff", flexShrink: 0 }} />
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <div style={{ fontSize: 12.5, fontWeight: 600, color: "#222", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.name}</div>
                                                    <div style={{ fontSize: 11, color: "#aaa" }}>{d.size}</div>
                                                </div>
                                                <a href={d.url} target="_blank" rel="noreferrer" style={styles.docBtn} title="Preview"><EyeOutlined /></a>
                                                <button style={{ ...styles.docBtn, color: "#ff4d4f" }} onClick={() => removeDoc(i)} title="Remove"><DeleteOutlined /></button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </SectionCard>

                            {/* <div style={styles.cta}>
                                <Button danger size="large" onClick={onBack}>Clear</Button>

                                {!existingUser ? (
                                    <Dropdown size="large" menu={{ items, onClick: handleMenuClick }}>
                                        <Button icon={<DownOutlined />} size="large" iconPlacement="start" loading={loading}>
                                            Actions
                                        </Button>
                                    </Dropdown>
                                ) : (
                                    <Button icon={<SaveOutlined />} type="primary" size="large" onClick={handleUpdate} loading={loading}>
                                        Save changes
                                    </Button>
                                )}
                            </div> */}

                            <div style={styles.cta}>
                                <Button danger size="large" onClick={() => {
                                    if (selectedUpcoming) {
                                        // deselect upcoming
                                        setSelectedUpcoming(null);
                                        setIsNewReservation(false);
                                        if (existingUser?.length > 0) {
                                            const u = existingUser[0];
                                            setForm({ ...emptyForm, ...u, guests: Number(u.guests) || 1 });
                                        } else {
                                            setForm(emptyForm);
                                        }
                                    } else {
                                        onBack();
                                    }
                                }}>
                                    {selectedUpcoming ? "Deselect" : "Clear"}
                                </Button>

                                {/* Show Save when editing upcoming OR existing user */}
                                {/* {(selectedUpcoming || (!isNewReservation && existingUser)) ? (
                                    <Button icon={<SaveOutlined />} type="primary" size="large"
                                        onClick={handleUpdate} loading={loading}>
                                        Save changes
                                    </Button>
                                ) : (
                                    <Dropdown size="large" menu={{ items, onClick: handleMenuClick }}>
                                        <Button icon={<DownOutlined />} size="large" loading={loading}>
                                            Actions
                                        </Button>
                                    </Dropdown>
                                )} */}

                                {/* Was: (selectedUpcoming || (!isNewReservation && existingUser)) */}
                                {(selectedUpcoming || (!isNewReservation && existingUser) || isOnlineBookingView) ? (
                                    <Tooltip title={!canUpdateModule(MODULE_KEY) ? "No permission to save changes" : ""}>
                                        <Button
                                            icon={<SaveOutlined />}
                                            type="primary"
                                            size="large"
                                            disabled={!canUpdateModule(MODULE_KEY)}
                                            onClick={handleUpdate}
                                            loading={loading}
                                        >
                                            Save changes
                                        </Button>
                                    </Tooltip>
                                ) : (
                                    <Tooltip title={!canCreateModule(MODULE_KEY) ? "No permission to book room" : ""}>
                                        <Dropdown
                                            size="large"
                                            menu={{ items, onClick: handleMenuClick }}
                                            disabled={!canCreateModule(MODULE_KEY)}
                                        >
                                            <Button
                                                icon={<DownOutlined />}
                                                size="large"
                                                loading={loading}
                                                disabled={!canCreateModule(MODULE_KEY)}
                                            >
                                                Actions
                                            </Button>
                                        </Dropdown>
                                    </Tooltip>
                                )}
                            </div>
                        </>)}
                    </div>
                </div>
            </Card>

            {/* ── Check-Out Modal (rendered outside Card to avoid z-index issues) ── */}
            <CheckOutModal
                open={checkOutModalOpen}
                onClose={() => setCheckOutModalOpen(false)}
                onConfirm={handleCheckOut}
                form={form}
                room={room}
                loading={checkOutLoading}
            />
            <CancleCheckModal
                open={cancelCheckModalOpen}
                onClose={() => setCancelCheckModalOpen(false)}
                onConfirm={handleCheckOut}
                form={form}
                room={room}
                loading={checkOutLoading}
            />

            <ServiceRequestModal
                open={serviceReqModalOpen}
                onClose={() => setServiceReqModalOpen(false)}
                form={form}
                room={room}
                loading={checkOutLoading}
            />
        </>
    );
}

/* ══════════════════════════════════════════════════════ */
/*  SUCCESS SCREEN                                        */
/* ══════════════════════════════════════════════════════ */
//   paidAmount })
function SuccessScreen({ bookId, room, form, nights, total, onBack, grandTotal, paidAmount, headerImg, gst }) {

    console.log("form", form);
    console.log("room************", room);


    return (
        <div style={{ ...styles.page, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "80vh" }}>
            <div style={styles.successCard}>
                <div style={styles.successIcon}><CheckCircleOutlined /></div>
                <div style={{ fontSize: 22, fontWeight: 700, color: "#111", marginBottom: 4 }}>Booking Confirmed!</div>
                <div style={{ fontSize: 13, color: "#888", marginBottom: 24 }}>
                    Booking ID: <b style={{ color: "#1677ff" }}>#{bookId}</b>
                </div>
                <div style={styles.successGrid}>
                    {[
                        ["Name", form.guest_name], ["Phone", form.phone],
                        // ["Phone", form.phone], ["Room No.", `#${room.room_number}`],


                        ["Room", room.room_name], ["Room No.", `#${room.room_number}`],
                        ["Guest", form.guest_name], ["Phone", form.phone],
                        ["Check-In", form.check_in], ["Check-Out", form.check_out],
                        ["Nights", nights], ["Guests", form.guests],
                        ["Payment", form.payment_mode], ["Total", `₹${total.toLocaleString()}`],
                    ].map(([k, v]) => (
                        <div key={k} style={styles.successRow}>
                            <span style={{ color: "#888", fontSize: 12 }}>{k}</span>
                            <span style={{ fontWeight: 600, fontSize: 13 }}>{v}</span>
                        </div>
                    ))}
                </div>
                <div style={styles.successGrid}>

                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>Grand Total</span>
                        <span style={{ fontWeight: 600, fontSize: 13 }}>{`₹${grandTotal.toLocaleString()}`}</span>
                    </div>

                    <div style={styles.successRow}>
                        <span style={{ color: "#888", fontSize: 12 }}>Paid Amount</span>
                        <span style={{ fontWeight: 600, fontSize: 13 }}>{`₹${paidAmount.toLocaleString()}`}</span>
                    </div>

                </div>

                <button style={{ ...styles.submitBtn, marginTop: 24, width: "100%", justifyContent: "center" }} onClick={onBack}>
                    <ArrowLeftOutlined style={{ marginRight: 7 }} /> Back to Rooms
                </button>

                <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={() => generatePDF({
                            form,      // Current form state
                            showUnitName: true,
                            bookId,    // Booking ID
                            rooms: [room],      // Room details
                            nights,    // Number of nights
                            total,     // Total amount
                            grandTotal, // Grand total (same as total in your case)
                            paidAmount,
                            headerImg,
                            gst
                        })}
                    >
                        🖨️ Print Bill
                    </button>

                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={() =>
                            generateA4PDF({
                                form,      // Current form state
                                bookId,    // Booking ID
                                rooms: [room],      // Room details
                                nights,    // Number of nights
                                total,     // Total amount
                                grandTotal, // Grand total (same as total in your case)
                                paidAmount,
                                headerImg,
                                gst
                            })   
                        }
                    >
                        🖨️ Print A4
                    </button>


                    <button
                        style={{ ...styles.submitBtn, flex: 1 }}
                        onClick={onBack}
                    >
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}


const Badge = ({ cfg }) => (
    <span style={{ fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 20, background: cfg.badgeBg, color: cfg.badgeColor }}>
        {cfg.label}
    </span>
);

const Divider = () => <div style={{ height: 1, background: "rgba(0,0,0,0.07)", margin: "14px 0" }} />;

const FormField = ({ label, required, error, span = 1, children }) => (
    <div style={{ gridColumn: `span ${span}` }}>
        <label style={styles.label}>{label} {required && <span style={{ color: "#ff4d4f" }}>*</span>}</label>
        {children}
        {error && <div style={{ fontSize: 11, color: "#ff4d4f", marginTop: 3 }}>{error}</div>}
    </div>
);

const Input = ({ prefix, placeholder, value, onChange, type = "text", min, max }) => (
    <div style={styles.inputWrap}>
        {prefix && <span style={styles.inputPrefix}>{prefix}</span>}
        <input type={type} placeholder={placeholder} value={value} min={min} max={max}
            onChange={(e) => onChange(e.target.value)}
            style={{ ...styles.input, paddingLeft: prefix ? 32 : 12 }} />
    </div>
);

const Textarea = ({ placeholder, value, onChange, rows = 3 }) => (
    <textarea placeholder={placeholder} value={value} rows={rows} onChange={(e) => onChange(e.target.value)} style={styles.textarea} />
);

const Select = ({ value, options, onChange }) => (
    <select value={value} onChange={(e) => onChange(e.target.value)} style={styles.select}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
);

const NumberInput = ({ value, min, max, onChange }) => (
    <div style={styles.numberInput}>
        <button style={styles.numBtn} onClick={() => onChange(Math.max(min ?? 1, value - 1))}>−</button>
        <span style={{ minWidth: 28, textAlign: "center", fontWeight: 600, fontSize: 14 }}>{value}</span>
        <button style={styles.numBtn} onClick={() => onChange(max != null ? Math.min(max, value + 1) : value + 1)}>+</button>
    </div>
);